import { render, staticRenderFns } from "./cardHelp.vue?vue&type=template&id=aa8d963e&scoped=true"
import script from "./cardHelp.vue?vue&type=script&lang=js"
export * from "./cardHelp.vue?vue&type=script&lang=js"
import style0 from "./cardHelp.vue?vue&type=style&index=0&id=aa8d963e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8d963e",
  null
  
)

export default component.exports